/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { batchActions } from "redux-batched-actions";
// actions
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { editEmbed, viewAnalytics, deleteEmbed } from 'state/actions/embedsState/embeds_status';
import { resetEmbedState } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { displayModal } from 'state/actions/modal_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import LibraryPage from 'pages/dashboard/embeds/library/library';



/* ========== ~~~~~~~~~~ PAGE : EMBEDS : LIBRARY : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState, sessionStatus, accountData }) => ({
    accountUUID: sessionStatus.accountUUID,
    userFirstName: sessionStatus.userFirstName,
    isDataReceived: embedsState.embedsStatus.isDataReceived,
    clientEmbeds: embedsState.embedsStatus.clientEmbeds,
    clientSites: accountData.sites,
    mocked: sessionStatus.mocked,
    editPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('manageEmbeds')
});

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(location));
    	dispatch(changePage(location))
    },
    moveToEmbedCreationWithStateReset: () => {
        dispatch(batchActions([
            resetEmbedState(),
            resetContentState({ setInitialContentId: true }),
        ]));
        dispatch(updatePageDetails('dashboard/embeds/management/getstarted'));
        dispatch(updateStepDetails('getstarted'));
        dispatch(changePage('dashboard/embeds/management/getstarted'))
    },
    editEmbed: embedUUID => dispatch(editEmbed(embedUUID)),
    viewAnalytics: embedUUID => dispatch(viewAnalytics(embedUUID)),
    deleteEmbed: (embedUUID,accountUUID, callback) => dispatch(deleteEmbed(embedUUID, accountUUID, callback)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton)),
    resetEmbedAndContentState: () => dispatch(batchActions([
        resetEmbedState(),
        resetContentState({ setInitialContentId: false }),
    ]))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(LibraryPage);
